import {
  REVIEW_RATING,
  type ReviewRating,
} from "@-/dev.improve.haniverse.lib.cards.user-card.fsrs";
import { LearnDeckContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.context";
import { useMutation } from "@-/com.npmjs.tanstack__react-query";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";

/**
 * Commit a sentence drill's ratings and move to the next card.
 *
 * One `rate` action through the deck. The deck freezes the drill's state and per-word cards at
 * the commit (`useResolveSentenceCardSnapshot`), so a late speech result cannot change what is
 * rated; the scoring itself is `sentenceDrillCommitReviews` — on a FINISHED drill every produced
 * word is Easy and the chosen rating grades the revealed word, on an UNFINISHED one the word under
 * the cursor takes the rating and unreached words are left alone. One transaction, one advance.
 */
export function useSentenceDrillRatingMutation() {
  const [commit] = useContextSelectors(LearnDeckContext, (c) => c.commit);

  return useMutation({
    mutationFn: async (rating: ReviewRating = REVIEW_RATING.Again) => {
      commit({ kind: "rate", rating }, "button");
    },
    mutationKey: ["sentenceDrillRating"],
  });
}
